import { AddLayerObject } from 'maplibre-gl';

import { emptyGeoJSONSource } from '@/constants/constants';
import { getTailWindColors } from '@/utils/common';

import { AcresMapboxLayerIds, ZOOM_LEVELS } from '..';

const tailwindColors = getTailWindColors();
const jade = tailwindColors.jade.DEFAULT;

export const savedBoundariesLayer: AddLayerObject = {
  id: AcresMapboxLayerIds.SAVED_SELECTION,
  maxzoom: ZOOM_LEVELS.PARCELS.MAX,
  minzoom: ZOOM_LEVELS.TOWNSHIPS.MIN,
  paint: {
    'line-color': jade,
    'line-width': 4,
  },
  source: emptyGeoJSONSource,
  type: 'line',
};
